export { default } from './Menu'



// WEBPACK FOOTER //
// ./src/Menu/index.js